import xhrService from '../xhrService';
import { ReopenFindingApi, SignatureGroupType } from '@sw-sw/lib-certification';
import db from '../../db/db';

export const inspectionFindingReopeningLogApi: ReopenFindingApi = {
  show: (findingId: number) =>
    xhrService
      .get(`/api/findings/${findingId}/open`)
      .then((res) => res.data)
      .catch(({ response }) => {
        throw new Error(response.data.message);
      }),
  update: async (findingId: number) => {
    if (navigator.onLine) {
      return xhrService
        .post(`/api/findings/${findingId}/open`)
        .then((res) => res.data)
        .catch(({ response }) => {
          throw new Error(response.data.message);
        });
    } else {
      try {
        const finding = await db.findings.get(findingId);

        finding.date_completed = null;
        finding.sync.payload = finding.sync.payload.filter(
          (item: any) => item.method !== 'update',
        );

        const existingCertification = await db.certifications.get(
          finding.InspectionFindingModel.inspection_id,
        );

        existingCertification.userSignatures[SignatureGroupType.compliance] =
          [];
        existingCertification.sync.payload =
          existingCertification.sync.payload.filter(
            (item: any) => item.group !== 'compliance',
          );

        existingCertification.groupOptions['compliance'].enabled = false;
        if (
          existingCertification.groupOptions['compliance'].errors.indexOf(
            'Findings need to be completed prior to signing',
          ) === -1
        ) {
          existingCertification.groupOptions['compliance'].errors.push(
            'Findings need to be completed prior to signing',
          );
        }

        db.inspections.update(finding.InspectionFindingModel.inspection_id, {
          compliance_date: '',
        });
        db.certifications.update(
          finding.InspectionFindingModel.inspection_id,
          existingCertification,
        );

        const inspection = await db.inspections.get(
          finding.InspectionFindingModel.inspection_id,
        );

        if (!inspection) {
          throw new Error('Inspection not found');
        }

        await db.inspections.update(Number(inspection.id), {
          findings: [
            ...inspection!.findings.filter((f: any) => f.id !== findingId),
            finding,
          ],
        });

        return db.findings.put(finding).then(() => ({ finding }));
      } catch (error) {
        console.error('Error updating finding in offline mode:', error);
        throw new Error('Failed to update finding in offline mode');
      }
    }
  },
};

export default inspectionFindingReopeningLogApi;
